<template>
  <div class="strategy full-height linear-main3">
    <ld-header
      :title="$t('Q007','机场攻略')"
      transparent
      white
    />
    <!-- <div class="white font30 title">
      机场攻略  SB 让改的 +1
    </div> -->
    <div class="pad-8">
      <div class="pad-b-20">
        <van-field
          class="airport-cell round-sm"
          :label="city.airportName"
          input-align="center"
          :placeholder="$t('Q002','航站楼')" 
          @click="showPopupPicker=true"
          v-model="terminal"
          readonly
          label-width="60%"
        >
          <template slot="label">
            <div 
              :class="[city.airportName ? '' : 'gray']"
              @click.stop="toggle('city')"
            >
              {{ city.cityName }} <span v-show="city.airportName"> - </span>{{ city.airportName || '请选择机场' }}
            </div>
          </template>
        </van-field>
      </div>
      <div
        v-for="(info,index) in baseInfo"
        :key="index"
        class="pad-b-5"
      >
        <van-cell
          :title="info.name"
          is-link
          @click="toggle(info.ref)"
          class="round-sm"
        >
          <template slot="icon">
            <ld-icon
              class="icon main-color"
              :type="info.icon"
            />
          </template>
        </van-cell>
      </div>
    </div>
    <!--  -->


    <!--  -->
    <van-popup
      v-model="showPopupPicker"
      position="bottom"
      :close-on-popstate="true"
    >
      <van-picker
        show-toolbar
        :columns="terminalList"
        @confirm="onConfirm"
        @cancel="showPopupPicker=false"
      />
    </van-popup>
    <!--  -->
    <city
      ref="city"
      @selected="cityChange"
    />
    <!--  -->
    <taxi ref="taxi" />
    <!--  -->
    <bus
      ref="bus"
      :title="city.airportName"
      :three-code="city.threeCode"
      :terminal="terminal"
    />
    <!--  -->
    <airport
      ref="airport"
      :title="city.airportName"
      :three-code="city.threeCode"
      :terminal="terminal"
    />
    <!--  -->
    <phone
      ref="phone"
      :title="city.airportName"
      :three-code="city.threeCode"
      :terminal="terminal"
    />
  </div>
</template>
<script>
import {Cell,Field,Popup,Picker } from 'vant'
import City from 'Common/city'

import taxi from './component/taxi'
import bus from './component/bus'
import airport from './component/airport'
import phone from './component/phone'

const DEFAULT_CITY = {
  airportName: '首都国际机场',
  airportNameFillSpell: 'shoudouguojijichang',
  airportNameSimpleSpell: 'sdgjjc',
  cityId: '10119',
  cityName: '北京',
  cityNameFullSpell: 'beijing',
  cityNameSimpleSpell: 'BJ',
  international: 1,
  threeCode: 'PEK'
}

export default {
  name: 'Strategy',
  data() {
    return {
      fromLat: 0, //城市经度
      fromLon: 0, //城市纬度
            
      city:{},
      terminal: '',
      terminalList: [],
      parkDetail: '',//当前位置
      coordsType:'gcj02ll',
      baseInfo:[
        {name:this.$t('Q003','出租车'),ref:'taxi',icon:'iconjh_czc'},
        {name:this.$t('Q004','机场大巴/地铁'),ref:'bus',icon:'iconjh_gjc_dt'},
        {name:this.$t('Q017','机场信息'),ref:'airport',icon:'iconjichang1'},
        {name:this.$t('Q006','机场电话'),ref:'phone',icon:'icondianhua'},
      ],
      showPopupPicker:false
    }
  },
  components:{
    [Cell.name]:Cell,
    [Field.name]:Field,
    [Popup.name]:Popup,
    [Picker.name]:Picker,
    City,
    taxi,
    bus,
    airport,
    phone
  },
  methods: {
    cityChange(info){
      this.city=info
      this.queryApTrnInfo(info.threeCode)
    },
    onConfirm(value, index){
      this.terminal=value
      this.showPopupPicker=false
    },
    toggle(name){
      this.$refs[name].toggle()
    },
    showMyAddr(locationInfo) { //把定位得到的位置信息显示在页面
      if(locationInfo.state == 1) { //定位成功
        this.getCityInfo(locationInfo)
      } else { //定位失败
        this.$toast(locationInfo.str)
      }
    },
    getCityInfo(obj) { //根据经纬度获取城市信息
      this.fromLat = this.fromLat || obj.lat || obj.latitude || 0
      this.fromLon = this.fromLon || obj.lng || obj.longitude || 0
      var that = this
      this.$api['common/geocoder']({
        lat: this.fromLat,
        lng: this.fromLon,
        coordType:this.coordsType
      }).then(resp=> {
        if(resp.data && resp.data.city) {
          that.ycCityId = that.ycCityId || resp.data.cityId
          that.ycCityName = that.ycCityName || resp.data.city
          that.fromCityName = that.fromCityName || obj.addr
          that.airGl(that.ycCityId)
          that.queryTianqi()
        }
      })
    },

    getCityId(type, lat, lng) {// 获取城市 Id 
      this.$api['common/geocoder']({
        'lat': lat,
        'lng': lng
      }).then(res=> {
        var cityId = res.data.cityId
        if(type == 2) { // 接机
          this.jieQuery['supportCity'] = cityId
        } else if(type == 3) { // 送机
          this.songQuery['supportCity'] = cityId
        }
      })
    },

    airGl(cityId) {
      this.$api['tkStrategy/cityAirportMsg']('?id=' + cityId).then(resp=>{
        var respose = resp.data||{}
        if(respose){
          this.showArrAirport = respose[0].airportName
          this.threeCode = respose[0].threeCode
          this.queryApTrnInfo(this.threeCode)
        }else{
          this.$toast('当前城市无机场！')
        }
      })

    },
    queryApTrnInfo(threeCode) {
      this.terminalList=[]
      this.$api['tkStrategy/queryApTrnInfo']({
        threeCode: threeCode,
      }).then(resp=>{
        let respose = resp.data||[]
        respose.forEach(item=>{
          this.terminalList.unshift(item.terminal)
        })
        if(this.terminalList.length>0){
          this.terminal = this.terminalList[0]
        }
      })
    },
        
    //动态创建script标签
    jsonp: function(url) {
      var script = document.createElement('script')
      script.src = url
      document.body.append(script)
      document.body.removeChild(script)
    },
    //添加事件，查询天气
    queryTianqi() {
      var script = document.createElement('script')
      script.src = 'http://php.weather.sina.com.cn/iframe/index/w_cl.php?code=js&day=0&city=&dfc=1&charset=utf-8&callback=see'
      document.body.appendChild(script)

    },
  }
}

/* eslint-disable */

var see = function() {
	var s = '',
		r = '',
		q = ''
	for(s in window.SWther.w) {
		q = SWther.w[s][0]
		r = {
			city: s,
			date: SWther.add.now.split(' ')[0] || '',
			day_weather: q.s1,
			night_weather: q.s2,
			day_temp: q.t1,
			night_temp: q.t2,
			day_wind: q.p1,
			night_wind: q.p2
		},
		$('#w').html(q.s1 + ' ' + r.city)
	}
}
            
//获得今天的天气， 解析json数据，写入DOM
function getTodayWeather(response) {
	var doc = document
	doc.querySelector('.place').innerHTML = response.results[0].currentCity
	doc.querySelector('.date').innerHTML = response.results[0].weather_data[0].date
	var p = doc.getElementsByTagName('p')
	var result = response.results[0].index
	var today = response.results[0].weather_data[1]
	var i = 0
	for(var index in result) {
		for(var item in result[index]) {
			if(item == 'des') {
				p[i].innerHTML = result[index][item]
				i++
			}
		}
	}

	var daypic = doc.getElementById('day-pic')
	var nightpic = doc.getElementById('night-pic')
	var weatherspan = doc.querySelector('.weather-mess')
	var span = weatherspan.getElementsByTagName('span')
	daypic.src = today.dayPictureUrl
	nightpic.src = today.nightPictureUrl
	span[0].innerHTML = today.weather
	span[1].innerHTML = today.wind
	span[2].innerHTML = today.temperature
	span[3] = response.results[0].pm25
}
</script>
<style lang="less" scoped>
    .strategy{
    }
    .pad-8{
        padding: 8px;
    }
    .pad-b-20{
        padding-bottom:5px;
    }
    .pad-b-5{
        margin-bottom: 5px;
    }
    .icon{
        margin-right: 5px;
        min-width: 1em;
        height: 24px;
        font-size: 16px;
        line-height: 24px;
    }
    .title{
        padding: 20px 18px 0;
        height: 80px;
    }
</style>